import {
  ODataHeader,
  ODataString,
  //ODataDate,
  //ODataBoolean,
} from "pbas-vue-components";
import { translate2 } from "../trans2";
import { i18n } from "@/plugins/i18n";
import store from "@/store";
import { translate } from "../trans";

const EligibilityHeaders = [
  new ODataHeader({
    type: new ODataString("Id"),
    visible: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "headers.members_management.Employer",
    type: new ODataString("CurrentEmployer/Translations[]/Name", {
      getString: (item) => {
        return translate2(item.CurrentEmployer, "Name");
      },
    }),
    visible: true,
    allowVisibilityChange: true,
    sortable: true,
    searchable: true,
  }),
  new ODataHeader({
    type: new ODataString("CurrentEmployer/Translations[]/LanguageCode"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "headers.plancoveragecommencement.condition",
    type: new ODataString("Conditions", {
      getString: (item) => {
        if (item.Conditions === null || item.Conditions === undefined) {
          return;
        }
        return item.Conditions.map((o) => {
          const conditions = [];
          let expressions = [];
          if (
            o.TranslatedExpressions === null ||
            o.TranslatedExpressions === undefined
          ) {
            if (o.Expressions === null || o.Expressions === undefined) {
              return;
            } else {
              expressions = o.Expressions;
            }
          } else {
            expressions = o.TranslatedExpressions;
          }
          conditions.push(
            expressions
              .map((oo) => {
                console.log(oo);
                const dateNotExistsIndex = oo.indexOf(
                  " == '0001-01-01T00:00:00.000Z'"
                );
                console.log(dateNotExistsIndex);
                if (dateNotExistsIndex > -1) {
                  oo = oo.replace(" == '0001-01-01T00:00:00.000Z'", "");
                  oo = "\u2204 " + oo;
                }
                const dateExistsIndex = oo.indexOf(
                  " != '0001-01-01T00:00:00.000Z'"
                );
                console.log(dateExistsIndex);
                if (dateExistsIndex > -1) {
                  oo = oo.replace(" != '0001-01-01T00:00:00.000Z'", "");
                  oo = "\u2203 " + oo;
                }
                return oo;
              })
              .join(" and ")
          );
          const parts = [];
          if (o.PeriodType !== null && o.PeriodType !== undefined) {
            parts.push(i18n.t("enums." + o.PeriodType));
          }
          if (o.PeriodUnit !== null && o.PeriodUnit !== undefined) {
            parts.push(o.PeriodUnit.toString());
          }
          if (o.CheckCondition !== null && o.CheckCondition !== undefined) {
            parts.push(i18n.t("enums." + o.CheckCondition));
          }
          if (o.SkipCurrent) {
            parts.push("Skip Current");
          }
          parts.push(i18n.t("enums." + item.ChangeDate));
          if (parts.length > 0) {
            conditions.push(parts.join(" "));
          }
          return conditions.join(" ");
        }).join(", ");
      },
      getHtml: (item, type) => {
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 600px'>" +
          type.getString(item, type) +
          "</div>"
        );
      },
    }),
    visible: true,
    allowVisibilityChange: true,
    sortable: true,
    searchable: true,
  }),
  // new ODataHeader({
  //   title: "headers.plancoveragecommencement.apply_on",
  //   type: new ODataString("Conditions[]/PeriodUnit"),
  //   sortable: false,
  //   visible: false,
  //   allowVisibilityChange: false,
  //   version: 1,
  // }),
  // new ODataHeader({
  //   title: "headers.plancoveragecommencement.period_unit",
  //   type: new ODataString("Conditions[]/PeriodUnit"),
  //   sortable: false,
  //   visible: false,
  //   allowVisibilityChange: false,
  // }),
  // new ODataHeader({
  //   title: "headers.plancoveragecommencement.check_condition",
  //   type: new ODataString("Conditions[]/CheckCondition"),
  //   sortable: false,
  //   visible: false,
  //   allowVisibilityChange: false,
  // }),
  // new ODataHeader({
  //   title: "headers.plancoveragecommencement.skip_current",
  //   type: new ODataString("Conditions[]/SkipCurrent"),
  //   sortable: false,
  //   visible: false,
  //   allowVisibilityChange: false,
  // }),
  new ODataHeader({
    type: new ODataString("ChangeDate"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "components.plancreationwizard.assign_to",
    type: new ODataString("CurrentMemberGroup/Translations[]/Name", {
      getString: (item) => {
        const parts = [];
        parts.push(translate2(item.CurrentMemberGroup, "Name"));
        if (item.Class) {
          parts.push(item.Class);
        }
        if (item.DefaultCoverageStatus) {
          const lang = store.getters["common/language"];
          parts.push(translate(item.DefaultCoverageStatus, lang.language));
        }
        return parts.join(", ");
      },
      getHtml: (item, type) => {
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; max-width: 200px'>" +
          type.getString(item, type) +
          "</div>"
        );
      },
    }),
    visible: true,
    allowVisibilityChange: true,
    sortable: true,
    searchable: true,
  }),
  new ODataHeader({
    type: new ODataString("CurrentMemberGroup/Translations[]/LanguageCode"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    type: new ODataString("Class"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    type: new ODataString("DefaultCoverageStatus/Name"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    type: new ODataString("DefaultCoverageStatus/Translations[]/DisplayValue"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    type: new ODataString("DefaultCoverageStatus/Translations[]/LanguageCode"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
  }),
];

export default EligibilityHeaders;
